import { useMutation } from '@tanstack/react-query';
import { checkScore } from '../../../core/queries/scores';

type CheckScoreArgs = {
  externalId: string;
  externalContent?: string;
  externalContentOrigin: 'navegation' | 'course' | 'plano-adaptativo';
  externalCourseId?: string;
};

const useGetBadgeScores = () => {
  const {
    mutate,
    mutateAsync,
    data,
    isSuccess,
    isPending,
  } = useMutation({
    mutationKey: ['use-get-badge-scores'],
    mutationFn: (args: CheckScoreArgs) => checkScore(args),
    retry: false,
  });

  const getBadgeScores = (
    args: CheckScoreArgs,
    onSuccess?: (data: any) => void,
    onError?: (err: unknown) => void
  ) => {
    mutate(args, {
      onSuccess,
      onError,
    });
  };

  return {
    getBadgeScores,
    getBadgeScoresAsync: mutateAsync, 
    badgeScore: data,
    isSuccess,
    isPending,
  };
};

export default useGetBadgeScores;
